import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { IMG, EXPERIENCES } from "../data/content";

export default function Experiences({ items = EXPERIENCES }) {
  return (
    <section id="experiences" data-testid="experiences-section" className="scroll-mt-20 bg-forest py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">Experiences</p>
        </Reveal>
        <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
          <Reveal delay={0.1}>
            <h2 className="max-w-xl font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
              <Link data-testid="home-experiences-page-link" to="/experiences" className="text-inherit no-underline">
                The wild is <span className="italic text-brass">the experience.</span>
              </Link>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-md text-sm leading-relaxed text-ivory/60">
              Nothing here is staged or scheduled. These are the ways the forest lets you in.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((exp, i) => (
            <Reveal key={exp.title} delay={(i % 3) * 0.12}>
              <article data-testid={`experience-card-${i}`} className="group cursor-pointer">
                <div className="relative overflow-hidden">
                  <img
                    src={IMG[exp.image] || exp.image}
                    alt={`${exp.title} at The Jamoon in Corbett`}
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-transparent to-transparent" />
                  <span className="absolute left-5 top-5 font-serif text-lg italic text-ivory/70">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="absolute bottom-5 left-5 right-5 font-serif text-2xl font-light text-ivory">
                    {exp.title}
                  </h3>
                </div>
                <p className="mt-4 border-l border-brass/30 pl-4 text-sm leading-relaxed text-ivory/60 transition-colors duration-500 group-hover:text-ivory/85">
                  {exp.text}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
